<template>
  <div class="privilege-management">
    <div class="privilege-management-top">
      <div class="classification">
        <span :class="active==1?'active':''" @click="btnClick(1)">用户</span>
        <span>|</span>
        <span :class="active==2?'active':''" @click="btnClick(2)">权限</span>
      </div>
    </div>
    <div class="privilege-management-bottom">
      <div v-if="active==1">
        <user></user>
      </div>
      <div v-if="active==2">
        <privilege></privilege>
      </div>
    </div>
  </div>
</template>

<script>
import User from "./user.vue";
import Privilege from "./privilege.vue";
export default {
  data () {
    return {
      active:1,
    }
  },
  mounted() {
    this.$nextTick(function() {
    });
  },
  beforeRouteEnter(to, from, next) {
    window.document.querySelector("body").setAttribute("style", "background-image:none");
    window.document.body.style.backgroundColor = "#EFEFEF";
    next();
  },
  beforeRouteLeave(to, from, next) {
    window.document.body.style.backgroundColor = "#001928";
    next();
  },
  methods: {
    btnClick(num){
      this.active = num;
    },
  },
  components: {
    User,
    Privilege,
  },
}
</script>

<style scoped lang="scss">
.privilege-management {
  .privilege-management-top {
    width: 98%;
    height: 60px;
    margin-left: 1%;
    margin-top: 16px;
    background-color: #ffffff;
    text-align: left;
    .classification {
      display: inline-block;
      line-height: 60px;
      margin-left: 1%;
      span {
        margin-right: 20px;
        color: #999999;
        font-size: 16px;
        cursor: pointer;
      }
      span.active {
        color: #0177BD;
        font-weight: 600;
      }
    }
  }
  .privilege-management-bottom {
    width: 98%;
    background-color: #ffffff;
    padding:20px 0;
    margin-left: 1%;
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/systemManagement/privilegeManagement.vue